import type { RenderOutputResolution } from '@/types/api';

/** RVE export presets scale the short edge to 720 / 1080 / 2160. */
const SHORT_EDGE_PX: Record<RenderOutputResolution, number> = {
  HD: 720,
  FHD: 1080,
  UHD: 2160,
};

/**
 * Map Neo ``renderVideo`` inputProps (logical canvas + optional Remotion scale)
 * to Aspectly ``output_resolution``.
 *
 * RVE ``use-render`` sets ``scale = exportShort / logicalShort`` and omits ``scale``
 * when it is 1 (typical 16:9 720p or 9:16 1080p).
 */
export function outputResolutionFromNeoInputProps(inputProps: {
  width?: unknown;
  height?: unknown;
  scale?: unknown;
}): RenderOutputResolution {
  const width = Number(inputProps.width);
  const height = Number(inputProps.height);
  const logicalShort = Math.min(
    Number.isFinite(width) && width > 0 ? width : 1280,
    Number.isFinite(height) && height > 0 ? height : 720,
  );
  const scaleRaw = inputProps.scale;
  const scale =
    typeof scaleRaw === 'number' && Number.isFinite(scaleRaw) && scaleRaw > 0
      ? scaleRaw
      : 1;
  const exportShort = logicalShort * scale;
  if (exportShort >= (SHORT_EDGE_PX.FHD + SHORT_EDGE_PX.UHD) / 2) {
    return 'UHD';
  }
  if (exportShort >= (SHORT_EDGE_PX.HD + SHORT_EDGE_PX.FHD) / 2) {
    return 'FHD';
  }
  return 'HD';
}
